
import Vue from 'vue'
import { getUserView } from '@/service/restService'
Vue.mixin({
  methods: {
    getPercentageChange (a, b) {
      if (a === 0 || b === 0) {
        return 'NA'
      }
      return ((b - a) / b * 100.0).toFixed(2) + '%'
    },
    getTime (time) {
      // eslint-disable-next-line standard/object-curly-even-spacing
      return new Date(time).toLocaleTimeString('en-US', { hour12: false, hour: 'numeric', second: 'numeric', minute: 'numeric'})
    },
    getDateTime (time) {
      // eslint-disable-next-line standard/object-curly-even-spacing
      return new Date(time).toLocaleString('en-GB')
    },
    getUserView: function () {
      getUserView().then((response) => {
        this.$store.commit('updateUser', response.data)
      }).catch((error) => {
        this.$store.commit('addToast', {
          title: 'Failure!',
          type: 'error',
          message: error.response.data.message[0]
        })
      })
    },
    isMobile () {
      return new window.MobileDetect(window.navigator.userAgent).mobile()
    },
    isWebView () {
      return window.navigator.userAgent.includes('megabull')
    },
    getVersion () {
      const match = window.navigator.userAgent.match(/Version:(\d+)$/)
      const version = match ? parseInt(match[1], 10) : null
      return version
    },
    triggerAndroidFunction (str) {
      if (window.AndroidInterface) {
        window.AndroidInterface.onButtonClick(str)
      } else {
        console.log('AndroidInterface not available')
      }
    }
  }
}
)



// WEBPACK FOOTER //
// ./src/service/utils.js